module.exports = __webpack_public_path__ + "img/sport-36-@1x.449e538e.png";